// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const AiApiSpec_emptySchema = z.object({});
